import React from 'react';

// import './styles.scss';

import {end} from '../../utils/beforeunload';
import strings from '../../utils/strings';
import ferdigLydSe from '../../assets/sounds/adult/se/testIsFinished.mp3';
import AudioPlayer from '../AudioPlayer';

class Ferdig extends React.Component {
	constructor() {
		super();
		const language = strings.getLanguage();
		const previewAudioObj = {
			se: ferdigLydSe,
		};
		this.audio = previewAudioObj[language];
	}
	componentDidMount() {
		end();
		window.localStorage.removeItem('authtoken-screening');
		setTimeout(function () {
			window.location = '/';
		}, 10000);
	
	}

	render() {
		return (
			<div>
				<h1 className="lit-page-title">{strings.done}</h1>
				
					<p className="lit-page-description"> <AudioPlayer
					autoplay
					inline
					src={this.audio}
				/>{strings.doneCongrats}</p>
			
			</div>
		);
	}
}

export default Ferdig;
